<!-- 模型专区 -->
<template>
  <div class='inside-component model-course'>
    <!-- 上滑加载组件 -->
    <cp-page-scroll
      v-show="courseList.length"
      @load="load"
      :upFinish="upFinish"
      :isref="isref"
      ref="pageScroll"
    >
      <div class="container-water-fall" v-if="courseList.length">
        <waterfall :col='2' :data="courseList" @loadmore="loadmore" @scroll="scroll">
          <template>
              <div class="cell-item" v-for="(item,index) in courseList" :key="index">
                <div class="item" @click="showModel(item)">
                  <div class="img-contain">
                    <img :src="formatAliyunPath(item.coverImage)" />
                  </div>
                  <h3 v-text="item.name"></h3>
                </div>
              </div>
          </template>
        </waterfall>
      </div>
    </cp-page-scroll>
  </div>
</template>

<script>
import { course, aliyun } from '@/agent'
export default {
  name: 'ModelCourse',
  props: {
    currentIndex: {
      default: ''
    },
    swiperIndex: {
      default: ''
    },
  },
  data () {
    return {
      courseList: [],
      params: {
        pageNum: 1,
        pageSize: 5
      },
      upFinish: false, // 是否已加载全部
      isref: true, // 节流
    }
  },
  components: {},
  computed: {
  },
  mounted () {
    this.getModalList()
  },
  methods: {
    showModel (item) {
      console.log(this.tabIndex)
      localStorage.setItem('playerCyData', JSON.stringify(item))
      this.$router.push({ path: '/model', query: { modelId: item.id, backPath: 'course', currentIndex: this.currentIndex, swiperIndex: this.swiperIndex } })
    },
    // 获得vr专区 场景模块  获取场景列表分页
    getModalList (resetList = false) {
      console.log('11111111111111')
      console.log(this.currentIndex)
      console.log(this.swiperIndex)
      this.$loading.show()
      let params = {
        pageNum: this.params.pageNum,
        pageSize: this.params.pageSize,
        query: {},
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          },
          {
            sortPropertyName: 'modifyTime',
            sortType: 'DESC'
          }
        ]
      }
      course.getModalList(params).then(res => {
        if (res.code == 100) {
          this.$loading.hide()
          this.courseList = resetList ? res.data.list : [...this.courseList, ...res.data.list]
          if (this.params.pageNum >= res.data.pages) {
            this.upFinish = true
            this.isref = false
          } else {
            this.params.pageNum += 1
            this.upFinish = false
            this.isref = true
          }
        } else {
          this.isref = false // 请求失败下次不可以请求
          this.upFinish = true// 显示 没有更多了
        }
        this.$refs.pageScroll.hideLoading() // 底部加载loading隐藏
      })
    },
    load () {
      // 防止多次上滑动导致page等于2没加载出来就加载page等于3的内容
      this.getModalList()
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
    // 布局
    scroll (scrollData) {

    },
    loadmore (index) {
    }
  }
}

</script>

<style lang='scss' scoped>
  .cell-item{
    margin-bottom: 10px;
  }
  .item{
    background: #fff;
    border-radius: 2px;
    overflow: hidden;
    h3{
      margin-top: 20px;
      height: 15px;
      opacity: 1;
      font-size: 15px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      text-align: center;
      color: #828282;
      line-height: 15px;
      letter-spacing: 0px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .img-contain{
      width: 105px;
      height: 76px;
      overflow: hidden;
      margin: 0 auto;
      img{
        height: 100%;
        width: auto;
        display: block;
        opacity: 1;
        margin: 0 auto;
      }
    }
  }
</style>
<style lang='scss'>
.model-course{
 .container-water-fall {
    padding: 20px;
    width:100%;
    box-sizing: border-box;
  }
  .cell-item {
    background: #f2f2f2 !important;
    overflow: hidden;
    box-sizing: border-box;
  }
  .cell-item img {
    width: 100%;
    height: auto;
    display: block;
  }
  .vue-waterfall-column:nth-child(2){
    .item{
      margin-right: 5px;
      padding:38px 12px 12px 12px;
      img{
        width: 63px;
      }
    }
  }
  .vue-waterfall-column:last-child{
    .item{
      margin-left: 5px;
      padding:42px 12px 18px 12px;
      img{
        width: 70px;
      }
    }
  }
}
</style>
